import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

// ─── Helpers de leitura segura do localStorage ────────────────────────────────
const readJSON = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  // FIX: lê o localStorage diretamente no estado inicial.
  // Assim user nunca começa como null quando há sessão salva —
  // eliminando o redirect falso para /login no primeiro render.
  const [user, setUser] = useState(() => readJSON("user"));
  const [clienteSelecionado, setClienteSelecionadoState] = useState(
    () => readJSON("clienteSelecionado")
  );

  // loading: false desde o início porque o estado já foi hidratado acima.
  // Mantido aqui caso você queira futuramente validar o token via API.
  const [loading, setLoading] = useState(false);

  const setClienteSelecionado = (cliente) => {
    setClienteSelecionadoState(cliente);
    localStorage.setItem("clienteSelecionado", JSON.stringify(cliente));
  };

  const login = (userData, token) => {
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("clienteSelecionado");
    setUser(null);
    setClienteSelecionadoState(null);
  };

  const clienteAtivo = () => {
    if (!clienteSelecionado) return false;
    return clienteSelecionado.ativo === true;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        clienteSelecionado,
        setClienteSelecionado,
        clienteAtivo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};